import { useEffect, useState } from 'react';
import { previewCalc } from '../../utils/timesheetsApi';

/**
 * THE AS-YOU-TYPE CALCULATION (owner, 2026-10-26: "update-as-you-type"). The
 * grids' grey O/T rows come from the server; with unsaved edits this asks the
 * server's calculator (`POST /api/timesheets/calc-preview`) for the DRAFTED
 * days, debounced, so the figures follow the typing. The client never does
 * the sum itself (house money rule: one calculator, on the server).
 *
 * `requests` = `[{ key, ...inputs }]` for the drafted days only (empty = no
 * call). Returns `{ [key]: calc | null }` for the latest answered request (a blank wrap's
 * server-worked AUTO WRAP rides on it as `calc.auto_wrap = { wrap, explain }`);
 * a stale answer (the edits moved on) is dropped.
 */
export default function useCalcPreview(requests, enabled = true) {
  const sig = enabled && requests.length ? JSON.stringify(requests) : '';
  const [result, setResult] = useState({ sig: '', byKey: {} });
  useEffect(() => {
    if (!sig) return undefined;
    let live = true;
    const timer = setTimeout(async () => {
      try {
        const r = await previewCalc(JSON.parse(sig));
        if (!live || !r.ok || !r.body || !Array.isArray(r.body.days)) return;
        const byKey = {};
        // The AUTO WRAP (2026-10-28) rides on its day's calc: there is a calc whenever there is one.
        for (const d of r.body.days) byKey[d.key] = d.calc && d.auto_wrap ? { ...d.calc, auto_wrap: d.auto_wrap } : d.calc;
        setResult({ sig, byKey });
      } catch (_) { /* a failed preview leaves the saved figures showing */ }
    }, 250);
    return () => { live = false; clearTimeout(timer); };
  }, [sig]);
  return result.sig === sig ? result.byKey : {};
}
